import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import z from "zod";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { orpc } from "@/orpc/client";

export const Route = createFileRoute("/_app/channels/$channelId/geolocation")({
	component: Page,
	params: z.object({
		channelId: z.coerce.number(),
	}),
	async loader({ context, params }) {
		context.queryClient.prefetchQuery(
			orpc.channels.show.queryOptions({
				input: {
					channelId: params.channelId,
				},
			}),
		);
	},
});

function Page() {
	const params = Route.useParams();

	const { data: _channel } = useSuspenseQuery(
		orpc.channels.show.queryOptions({
			input: {
				channelId: params.channelId,
			},
		}),
	);

	return (
		<div className="px-4 lg:px-6 grid grid-cols-12 gap-6">
			<Card className="col-span-12">
				<CardHeader>
					<CardTitle>Geolocation</CardTitle>
				</CardHeader>
				<CardContent className="grid grid-cols-12 gap-6"></CardContent>
			</Card>
		</div>
	);
}
